import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ApiService } from "./api.service";

@Injectable({
  providedIn: "root",
})
export class DashboardService {
  percentagesTripCompliance = new BehaviorSubject<any>(0);
  percentagesDeliveryDate = new BehaviorSubject<any>(0);
  percentagesClosedDispatch = new BehaviorSubject<any>(0);
  percentagesDeliveryConfirmation = new BehaviorSubject<any>(0);
  percentagesPickingDate = new BehaviorSubject<any>(0);
  percentagesPickDate = new BehaviorSubject<any>(0);

  totalDeliveryComplianceByCustomerStore = new BehaviorSubject<any>(0);
  totalDeliveryComplianceByEcommerce     = new BehaviorSubject<any>(0);
  totalDeliveryComplianceByMarketplace   = new BehaviorSubject<any>(0);



  constructor(private apiService: ApiService) {}

  /* ========================DESPACHO  a DOMICILIO ========================*/
  setDeliveredCustomerStore(total: number) {
    this.totalDeliveryComplianceByCustomerStore.next(total);
  }

   setDeliveredEcommerce(total: number) {
    this.totalDeliveryComplianceByEcommerce.next(total);
  }

  setDeliveredMarketplace(total: number) {
    this.totalDeliveryComplianceByMarketplace.next(total);
  }

  /* =============================================================== */
  setPercentagesTripCompliance(value: number, total: number) {
    this.percentagesTripCompliance.next((value / total) * 100);
  }

  setPercentagesDeliveryDate(value: number, total: number) {
    this.percentagesDeliveryDate.next((value / total) * 100);
  }

  setPercentagesClosedDispatch(value: number, total: number) {
    this.percentagesClosedDispatch.next((value / total) * 100);
  }

  setPercentagesDeliveryConfirmation(value: number, total: number) {
    this.percentagesDeliveryConfirmation.next((value / total) * 100);
  }

  setPercentagesPickingDate(value: number, total: number) {
    this.percentagesPickingDate.next((value / total) * 100);
  }

  setPercentagesPickDate(value: number, total: number) {
    this.percentagesPickDate.next((value / total) * 100);
  }

    /* ============Servicio 1: Cumplimiento ​de Viaje en Transito &&   */
    getTripCompliance(request: any): Observable<any> {
      const url = this.apiService.tripCompliance + "?" + request;
      return this.apiService.get(url);
    }

    /* ============Servicio 2: Fecha de TRX de entrega vs fecha entrega real  */
    getDeliveryDate(request: any): Observable<any> {
      const url = this.apiService.deliveryDate + "?" + request;
      return this.apiService.get(url);
    }

    /* ===============Servicio 3: Despachos cerrados segun antiguedad======================= */
    getClosedDispatch(request: any): Observable<any> {
      const url = this.apiService.closedDispatch + "?" + request;
      return this.apiService.get(url);
    }

    /* ===============Servicio 4: Confirmación de Entrega======================= */
    getDeliveryConfirmation(request: any): Observable<any> {
      const url = this.apiService.deliveryConfirmation + "?" + request;
      return this.apiService.get(url);
    }

    /* ============Servicio 5: Fecha Picking vs Fecha de Venta=============== */
    getDateOfSale(request: any): Observable<any> {
      const url = this.apiService.pickingDateVsSaleDate + "?" + request;
      return this.apiService.get(url);
    }

    /* ============Servicio 6: Fecha de recojo por parte del Cliente=============== */
    getPickupDate(request: any): Observable<any> {
      const url = this.apiService.pickupDateByClient + "?" + request;
      return this.apiService.get(url);
    }

    /* ============Servicio 7: Cumplimiento ​de Entrega por compañia - FUERA DE FECHA (complianceStatus)=============== */
    getComplianceSaleNotesByCompany(request: any): Observable<any> {
      const url = this.apiService.deliveryComplianceByCompany + "?" + request;
      return this.apiService.get(url);
    }

    /* ============Servicio 7: Cumplimiento ​de Entrega por plataforma - FUERA DE FECHA (platformOrigin)=============== */
    getComplianceSaleNotesByPlatform(request: any): Observable<any> {
      const url = this.apiService.deliveryComplianceByPlatform + "?" + request;
      return this.apiService.get(url);
    }

    /* ============Servicio 8: Cumplimiento ​de Entrega por Origen - FUERA DE FECHA (complianceStatus)=============== */
    getDeliveryDateByOriginType(request: any): Observable<any> {
      const url = this.apiService.deliveryCompliance + "?" + request;
      return this.apiService.get(url);
    }

    /* ============Servicio 9: Cumplimiento ​InFull - COMPLETO (complianceInfull)=============== */
    getComplianceInfullByOriginType(request: any): Observable<any> {
      const url = this.apiService.complianceInfull + "?" + request;
      return this.apiService.get(url);
    }

    //RETIRO EN TIENDA
    /* ============Servicio 10: Cumplimiento ​de Entrega por compañia - FUERA DE FECHA (complianceStatus)=============== */
    getArrivalSaleNotesByCompany(request: any): Observable<any> {
      const url = this.apiService.arrivalComplianceByCompany + "?" + request;
      return this.apiService.get(url);
    }

    /* ============Servicio 11: Cumplimiento ​de Entrega por plataforma - FUERA DE FECHA (platformOrigin)=============== */
    getArrivalSaleNotesByPlatform(request: any): Observable<any> {
      const url = this.apiService.arrivalComplianceByPlatform + "?" + request;
      return this.apiService.get(url);
    }

    /* ============Servicio 12: Cumplimiento ​de Arribo a última Entidad por Origen - FUERA DE FECHA (complianceStatus)=============== */
    getArrivalDateByOriginType(request: any): Observable<any> {
      const url = this.apiService.arrivalComplianceByDispatch + "?" + request;
      return this.apiService.get(url);
    }

    /* ============Servicio 8:Cumplimiento ​de Ubicación en Tienda - RETIRO EN TIENDA (complianceLocation)=============== */
    getComplianceLocationByCompany(request: any): Observable<any> {
      const url = this.apiService.complianceLocationByCompany + "?" + request;
      return this.apiService.get(url);
    }

    /* ============Servicio 8:Cumplimiento ​de Ubicación en Tienda - FUERA DE FECHA (complianceLocation)=============== */
    getComplianceLocationByOriginType(request: any): Observable<any> {
      const url = this.apiService.complianceLocationByDispatch + "?" + request;
      return this.apiService.get(url);
    }

    /* ============CONSOLIDADO :Cumplimiento ​de Entregas por Notas de Venta - POR COMPAÑÍA ()=============== */
    getComplianceSaleNoteByCompany(request: any): Observable<any> {
      const url = this.apiService.complianceSaleNoteByCompany + "?" + request;
      return this.apiService.get(url);
    }

    /* ============CONSOLIDADO :Cumplimiento ​de Entregas por Notas de Venta - POR PLATAFORMA ()=============== */
    getComplianceSaleNoteByPlatform(request: any): Observable<any> {
      const url = this.apiService.complianceSaleNoteByPlatform + "?" + request;
      return this.apiService.get(url);
    }

    /* ============CONSOLIDADO :Cumplimiento ​de Entregas por Notas de Venta - POR DESPACHOS ()=============== */
    getComplianceSaleNoteByDispatch(request: any): Observable<any> {
      const url = this.apiService.complianceSaleNoteByDispatch + "?" + request;
      return this.apiService.get(url);
    }

    /* ============CONSOLIDADO :Cumplimiento ​de Entregas por Notas de Venta - POR DESPACHOS ()=============== */
    getDeliveryComplianceByType(request: any): Observable<any> {
      const url = this.apiService.deliveryComplianceByOrigin + "?" + request;
      return this.apiService.get(url);
    }
    /* ============CONSOLIDADO :Cumplimiento ​de Entregas por Notas de Venta - POR DESPACHOS ()=============== */
    getStorePickupOrHomeDeliveryByType(request: any): Observable<any> {
      const url = this.apiService.storePickupOrHomeDeliveryByType + "?" + request;
      return this.apiService.get(url);
    }
  }
